import { render, staticRenderFns } from "./afternoonHealth.vue?vue&type=template&id=06885895&scoped=true&"
import script from "./afternoonHealth.vue?vue&type=script&lang=ts&"
export * from "./afternoonHealth.vue?vue&type=script&lang=ts&"
import style0 from "./afternoonHealth.vue?vue&type=style&index=0&id=06885895&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06885895",
  null
  
)

export default component.exports